import { Injectable } from '@angular/core';
import { LckrHttpService } from './lckrHttp.service';
import { HttpClient } from '@angular/common/http';
import { webSocket } from 'rxjs/webSocket';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LckrService {

  constructor(private httpService:LckrHttpService,private http:HttpClient) { }
  postFinderData(payload:any){
    return this.httpService.post('dashboard/lckr/?type=S',payload)
  }
  getFinderData(type:any){
    return this.httpService.get(`dashboard/lckr${type}`)
  }
  getDashboardData(query:string){
    return this.httpService.get(`dashboard/keyword?${query}`)
  }
  analyseDashboardData(query:any,payload:any){
    return this.httpService.post(`dashboard/analyze_keywords_data?${query}`,payload)  
  }
  postGlobalSettings(payload:any){
    return this.httpService.post(`dashboard/lckr_settings_outer?uid=${payload.uid}`,payload)  
  }
  getSocketRes(lid:string){
    return webSocket(`${environment.socketUrl}socket/lckr-kws/${lid}`);
  }
  getListSocketRes(lid:string){
    return webSocket(`${environment.socketUrl}socket/lckr-kws/${lid}-list-id`);
  }
  getDashboardSocketRes(lid:string){
    return webSocket(`${environment.socketUrl}socket/lckr/${lid}`);
  }
  getPaa(id:string,query:any){
    return this.httpService.get(`dashboard/lckr_paa?lid=${id}&${query}`)  
  }
  getRelatedSearches(id:string,query:any){
    return this.httpService.get(`dashboard/lckr_related_searches?lid=${id}&${query}`)  
  }
  handleHideUnhide(payload:any) {
    return this.httpService.post('dashboard/hidden_kws',payload)
  } 
  saveIncludeExclude(id:string,payload:any){
    return this.httpService.post(`dashboard/lckr_exactpartialkw?lid=${id}`,payload)
  }
  getTopics(payload:any){
    return this.httpService.post(`dashboard/lckr_tags`,payload);
  }
  getTabCount(id:string){
    return this.httpService.get(`dashboard/lckr_tab_counts?lid=${id}`);
  }
  startClusters(payload:any){
    return this.httpService.post(`dashboard/clusters_creation`,payload);
  }
  getCompititors(id:string,query:any){
    return this.httpService.get(`dashboard/lckr_competitors?${query}`)  
  }
  getClusters(id:string,filterQuery:any){
    return this.httpService.get(`dashboard/lckr_clusters_get?${filterQuery}`);
  }
  importedReport(payload:any){
    return this.httpService.post(`dashboard/lckr_save__basekeywords?type=C`,payload);
  }
  deleteReport(payload:any){
    return this.httpService.post(`dashboard/delete_lckr`,payload);
  }
  addList(payload:any){
    return this.httpService.post(`dashboard/lckrlist/`,payload);
  }
  getList(){
    return this.httpService.get(`dashboard/lckrlist`);
  }
  editList(payload:any){
    return this.httpService.put(`dashboard/lckrlist/${payload.id}/`,payload);
  }
  deleteList(id:any){
    return this.httpService.delete(`dashboard/lckrlist/${id}/`);
  }
  getListDetails(payload:any,filterQuery:string = ""){
    return this.httpService.post(`dashboard/lckrlistdetail?${filterQuery}`,payload);
  }

  getListData(id:any){
    return this.httpService.get(`dashboard/lckrlistdetail/?list_id=${id}`);
  }
  getIncludeExclude(id:string,type:string){
    return this.httpService.get(`dashboard/lckr_exactpartialkw?lid=${id}&type=${type}`)
  }
  downloadExcel(payload:any){
    return this.httpService.post(`dashboard/download_excel`,payload);
  }
}
